<div class="product-results">
  {{ 'productList.categoryResultCount' | transloco: { count: productCount } }}
</div>
